<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3 handle-bottom">
            <div class="uers-right uers-right-buttom">
              <span class="btn-r">
                <el-button
                  type="primary"
                  plain
                  icon="el-icon-plus"
                  @click="addSubmit"
                  >新增</el-button
                >
              </span>
            </div>
          </div>
          <div class="tabbox">
            <el-table
              :data="dataList"
              height="100%"
              border
              class="table"
              ref="multipleTable"
              :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="55"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="名称"
                width="250"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="checkIn"
                label="次数"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.checkIn }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="banner"
                label="Banner"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                      style="width: 40px; height: 40px"
                      :src="scope.row.banner"
                      :preview-src-list="[scope.row.banner]"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="url" label="Url地址" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.url }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="enabled"
                label="状态"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.enabled == 1 ? "启用" : "禁用" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="startDate"
                label="开始时间"
                width="180"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.startDate }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="endDate"
                label="结束时间"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.endDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="handleEdit(scope.$index, scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    class="red"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
              class="pag"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
          :delVisible="delVisible"
          @deleteData="deleteData"
          @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditRegisterUI
          :editShow="editShow"
          :editData="editData"
          @backFunStu="getFunStu"
        ></EditRegisterUI>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditRegisterUI from "../../components/major/EditRaffle";
import DeleteDialog from "../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      editData: {},
      listShow: true,
      editShow: false,
      delVisible: false,
      dataList: [],
      multipleSelection: [],
      projectId: localStorage.getItem("project_Id"),
      raffle_Id: "",
    };
  },
  mounted() {
    // this.tabheight=(this.$refs.getheight.offsetHeight-165)
  },
  created() {
    this.getData();
  },
  methods: {
    open(url) {
      window.open(url);
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
      this.getData();
    },
    addSubmit() {
      this.register_Id ="";
      this.listShow = false;
      this.editShow = true;
      this.editData = null;
    },
    handleDelete(index, row) {
      this.register_Id = row.registerId;
      this.delVisible = true;
    },
    handleCloseVisible() {
      this.register_Id = "";
      this.delVisible = false;
    },
    deleteData() {
      this.$axios.delete(`/Raffle/${this.raffle_Id}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    // 获取数据
    getData() {
      this.$axios.get("/Raffle/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    getFunStu() {
      this.editData = null;
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  },
  components: {
    EditRegisterUI,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  margin-left: 10px;
  height: 100%;
}
.el-main {
  border-radius: 5px;
  position: relative;
}
.uers-right {
  float: right;
}
.uers-right-buttom {
  margin-bottom: 19px;
}
.handle-bottom {
  padding-bottom: 20px;
}
.import-bnt {
  float: right;
}
.el-upload--text {
  border: 0;
}
</style>